import { PRICING_STRATEGY } from '@schuettflix/interfaces';
import { ProductConfiguration } from '@/shared/models/ContextDataModel/interfaces/entities/product-configuration.ts';
import { PartialAutomaticProductsFormValues } from '../schema/getAutomaticProductsFormSchema.ts';
import { prefillAutomaticProductsForm } from './prefillAutomaticProductsForm.ts';

export function prefillAutomaticOrderForm(
    pricingStrategy: PRICING_STRATEGY,
    productConfigurations: ProductConfiguration[]
): PartialAutomaticProductsFormValues {
    const prefilled = prefillAutomaticProductsForm(pricingStrategy, productConfigurations);

    return {
        ...prefilled,
        scope: 'ORDER',
        salesMaterialQuantity: undefined,
        purchaseMaterialQuantity: undefined,
        salesTransportQuantity: undefined,
        purchaseTransportQuantity: undefined,
        additionalServices: prefilled.additionalServices?.map(service => ({
            ...service,
            salesQuantity: undefined,
            purchaseQuantity: undefined,
        })),
    };
}
